import script from "./ContactSelectionStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactSelectionStep.vue?vue&type=script&setup=true&lang=ts"

import "./ContactSelectionStep.vue?vue&type=style&index=0&id=159f6ce8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-159f6ce8"]])

export default __exports__